/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CustomLocalizationTarget {
  Frontend = 'frontend',
  Backoffice = 'backoffice',
  Email = 'email',
  Api = 'api'
}
